/** Recarregar a mesma URL não dispara POST; trocar de solicitação dispara, e o servidor só grava se houver dado novo. */
export function shouldRecordLeadAccess({
  didHandleInitialReload,
  lastRecordedLeadId,
  leadId,
  isReload,
  initialRouteLeadId,
}) {
  const leadKey = String(leadId);
  if (!didHandleInitialReload && isReload && initialRouteLeadId && String(initialRouteLeadId) === leadKey) {
    return { record: false, lastRecordedLeadId: leadKey, didHandleInitialReload: true };
  }
  if (String(lastRecordedLeadId || "") === leadKey) {
    return { record: false, lastRecordedLeadId: leadKey, didHandleInitialReload: true };
  }
  return { record: true, lastRecordedLeadId: leadKey, didHandleInitialReload: true };
}
